import './photoArchive.css'

import img1 from '../../../../assets/img/libro/img1.jpg'
import img2 from '../../../../assets/img/libro/img2.jpg'
import img3 from '../../../../assets/img/libro/img3.jpg'
import img4 from '../../../../assets/img/libro/img4.jpg'

const PhotoArchive = () => {
  
  return (
    <section className="photoArchive">

      {/* GALERÍA */}
      <div className="photoArchive__gallery">

        <div className="photoArchive__item">
          <img src={img1} alt="Archivo fotográfico 1" />
          <div className="photoArchive__overlay">
            Congreso Andaluz de Coeducación. Granada. Autora_ Carmen Borbolla. 2024.
          </div>
        </div>

        <div className="photoArchive__item">
          <img src={img2} alt="Archivo fotográfico 2" />
          <div className="photoArchive__overlay">
            Foto de Dani Sequi. Estampando bombachas menstruales y didácticas  de _El Valle Menstrua_, Córdoba Argentina
          </div>
        </div>

        <div className="photoArchive__item">
          <img src={img3} alt="Archivo fotográfico 3" />
          <div className="photoArchive__overlay">
            ATaller de educación menstrual para alumnas de secundaria (1º a 4º de ESO). CPI Zas, A Coruña, España. Autora_ Noelia Darriba García de AtalaiAS. s_f.
          </div>
        </div>

        <div className="photoArchive__item">
          <img src={img4} alt="Archivo fotográfico 4" />
          <div className="photoArchive__overlay">
            Taller dinamizado por Ara!Gorputz. Irún (Gipuzkoa)
          </div>
        </div>

      </div>

    </section>
  )
}

export default PhotoArchive
